export default __webpack_public_path__ + "static/media/about.fcc5b463.jpg";